import { gql } from "@apollo/client";
import { IMAGE_FRAGMENT } from "image/fragments";

import { ORGANIZATION_FRAGMENT } from "../organization";
import { ADDRESS_FRAGMENT } from "../address/fragments";

import { VENUE_FRAGMENT } from "./fragments";

export const CREATE_VENUE = gql`
  ${VENUE_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
  ${ADDRESS_FRAGMENT}
  ${IMAGE_FRAGMENT}
  mutation CreateVenue($input: VenueCreateInput!) {
    venueCreate(input: $input) {
      ...Venue
      address {
        ...Address
      }
      organization {
        ...Organization
      }
      image {
        ...Image
      }
    }
  }
`;

export const UPDATE_VENUE = gql`
  ${VENUE_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
  ${ADDRESS_FRAGMENT}
  ${IMAGE_FRAGMENT}
  mutation UpdateVenue($id: Int!, $input: VenueUpdateInput!) {
    venueUpdate(id: $id, input: $input) {
      ...Venue
      address {
        ...Address
      }
      organization {
        ...Organization
      }
      image {
        ...Image
      }
    }
  }
`;

export const DELETE_VENUE = gql`
  mutation DeleteVenue($id: Int!) {
    venueDelete(id: $id)
  }
`;
